const PreviewItem = ({ label, value, isEmptyShow = true }) => (
    (value != null && value != "") || isEmptyShow ?
    <div>
        <div className="text-xs text-gray-500">
            {label}
        </div>
        <div className="font-medium text-gray-800">
            {value || "-"}
        </div>
    </div> : <></>
);

export default PreviewItem;